import { Box, Flex } from "@chakra-ui/layout";
import { withPrefix } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import "../styles/index.scss";
import Header from "./Header";
import MobileDrawer from "./MobileDrawer";
import useSiteMetadata from "./SiteMetadata";

const TemplateWrapper = ({ children, location }) => {
  const { title, description } = useSiteMetadata();

  return (
    <Flex minH="100vh" height="100%" flexDir="column">
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <meta name="theme-color" content="#fff" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/og-image-new.jpg`}
        />
        <script async defer src="https://www.instagram.com/embed.js"></script>
      </Helmet>
      <Header location={location} />
      <Box flex="1" className="page-container">
        {children}
      </Box>
      <Footer />
      <MobileDrawer />
    </Flex>
  );
};

export default TemplateWrapper;
